import { LEGACY_TERMS } from '../terms/legacyTerms';
/** Kept for backwards compatibility (admin and external importers); values are the legacy wording. */
export const CASH_FLOW_LABELS = { ...LEGACY_TERMS.cash.flowLabel };
export const CASH_FLOW_SHORT_LABELS = { ...LEGACY_TERMS.cash.flowShortLabel };
export const CASH_STATUS_LABELS = {
    paid_full: 'Paid in full — credits issued',
    pending_payment: 'Pending payment — credits issued',
    partially_paid: 'Partially paid',
    cancelled: 'Cancelled',
};
export const CASH_PAYMENT_METHOD_LABELS = {
    cash: 'Cash',
    bank_transfer: 'Bank transfer',
    check: 'Check',
    other: 'Other',
};
export const CASH_FLOW_FILTER_OPTIONS = LEGACY_TERMS.cash.flowFilterOptions.map((o) => ({ ...o }));
export const CASH_STATUS_FILTER_OPTIONS = [
    { value: '', label: 'All' },
    { value: 'paid_full', label: CASH_STATUS_LABELS.paid_full },
    { value: 'pending_payment', label: CASH_STATUS_LABELS.pending_payment },
    { value: 'partially_paid', label: CASH_STATUS_LABELS.partially_paid },
    { value: 'cancelled', label: CASH_STATUS_LABELS.cancelled },
];
export const CASH_PAYMENT_METHOD_OPTIONS = [
    { value: 'cash', label: 'Cash' },
    { value: 'bank_transfer', label: 'Bank transfer' },
    { value: 'check', label: 'Check' },
    { value: 'other', label: 'Other' },
];
export const CASH_PAGE_SIZE_OPTIONS = [20, 50, 100];
